{
  "header": {
    "welcomeMessage": "Välkommen, {{firstName}}!",
    "description": "Granska och analysera tidigare feedbacksvar"
  },
  "emptyState": {
    "company": {
      "title": "Ingen data insamlad än",
      "description": "Din resa börjar här! När anställda börjar dela feedback under första månaden kommer du att se insikter och trender dyka upp"
    },
    "directReports": {
      "title": "Inga direktrapporter",
      "description": "Du har inga direktrapporter tilldelade, men du kan ändå delta i enkäter och dela värdefull feedback!",
      "bottomAction": {
        "label": "Om du tror att detta är ett misstag, kontakta din chef",
        "helpText": "Hjälptext"
      }
    }
  },
  "tabs": {
    "company": "Hela företaget",
    "allReports": "Alla rapporter",
    "directReports": "Direktrapporter",
    "myTeam": "Mitt team"
  },
  "keysInsights": {
    "title": "Viktiga insikter",
    "strengths": {
      "title": "Styrkor",
      "tooltipTitle": "Hjälptext"
    },
    "growthAreas": {
      "title": "Utvecklingsområden",
      "tooltipTitle": "Hjälptext"
    }
  },
  "enps": {
    "title": "eNPS",
    "chart": {
      "description": "eNPS mäter hur sannolikt det är att anställda rekommenderar sin arbetsplats, vilket speglar engagemang och nöjdhet"
    },
    "scoreTitle": "Ditt team",
    "companyAverageTitle": "Företagets eNPS"
  },
  "overview": {
    "title": "Översikt",
    "scoreTitle": "Ditt team",
    "companyAverageTitle": "Företagets genomsnitt"
  }
}
